import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/DashboardNavBar.scss";

const DashboardNavBar = (props) => {
  const navigate = useNavigate();

  return (
    <div className="header-navBar">
      <div className="navBar-containerEvaluacionIntro">
        {!props.hideNav && (
          <button
            className="p-link-button button-img "
            onClick={() => navigate(-1)}
          >
            <i
              className="pi pi-arrow-left"
              style={{ fontSize: "1rem", fontWeight: "bold" }}
            ></i>
          </button>
        )}

        <div className="flex align-items-center justify-content-between w-full">
          {props.titulo && (
            <div className="pl-2 text-lg font-bold text-lg-mobile">
              {props.titulo}
            </div>
          )}
          {props.adicional && (
            <div className="text-lg text-lg-mobile">{props.adicional}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardNavBar;
